export const SLIDER_TEST_IDS = {
  root: 'slider',
  track: 'slider_track',
  range: 'slider_range',
  thumb: (index: number) => `slider_thumb_${index}`,
} as const;

export const TABS_TEST_IDS = {
  INDICATOR: 'tabs_indicator',
} as const;

export const BAR_CHART_HORIZONTAL_TEST_IDS = {
  SKELETON: 'bar-chart-horizontal_skeleton',
} as const;

export const COMPARISON_BAR_CHART_TEST_IDS = {
  SUCCESS: {
    PREV: 'comparison-bar-chart_success-prev',
    CURRENT: 'comparison-bar-chart_success-current',
  },
  DECLINED: {
    PREV: 'comparison-bar-declined-prev',
    CURRENT: 'comparison-bar-declined-current',
  },
} as const;

export const GAUGE_CHART_TEST_IDS = {
  SKELETON: 'gauge-chart_skeleton',
} as const;

export const ENPS_GAUGE_CHART_TEST_IDS = {
  CURRENT_MARKER: 'enps-gauge-chart_current-marker',
  PREVIOUS_MARKER: 'enps-gauge-chart_previous-marker',
} as const;

export const LINE_CHART_SIMPLE_TEST_IDS = {
  SKELETON: 'line-chart-simple_skeleton',
} as const;

export const METRICS_CARD_TEST_IDS = {
  SKELETON: 'metrics-card_skeleton',
} as const;

export const TOOLTIP_TEST_IDS = {
  TRIGGER: 'tooltip_trigger',
  CONTENT: 'tooltip_contente',
} as const;

export const PERFOMANCE_CARD_TEST_IDS = {
  SKELETON: 'perfomance-card_skeleton',
} as const;

export const ENPS_PERFORMANCE_CARD_TEST_IDS = {
  SKELETON: 'enps-performance-card_skeleton',
  BASELINE_MARKER: 'enps-performance-card_baseline-marker',
  SCORE_MARKER: 'enps-performance-card_score-marker',
} as const;

export const TEAM_PERFOMANCE_CARD_TEST_IDS = {
  SKELETON: 'team-perfomance-card_skeleton',
} as const;

export const PIE_CHART_SIPLE_CARD_TEST_IDS = {
  SKELETON: 'pie-chart-simple',
} as const;

export const TREND_CHART_SIPLE_CARD_TEST_IDS = {
  SKELETON: 'trend-chart-simple',
} as const;

export const CATEGORY_DISTRIBUTION_CARD_TEST_IDS = {
  ICON: 'category-distribution-card_icon',
  SKELETON: 'category-distribution_skeleton',
} as const;

export const INSIGHTS_CARD_TEST_IDS = {
  SKELETON: 'insights-card_skeleton',
} as const;

export const CHANGE_INDICATOR_TEST_IDS = {
  VALUE: 'change-indicator_value',
} as const;

export const QUESTION_CARD_TEST_IDS = {
  SKELETON: 'question-card_skeleton',
  BUTTON: 'question-card_button',
} as const;

export const COMPARISON_DROPDOWN_TEST_IDS = {
  ADD_BUTTON: 'comparison-dropdown_add_button',
} as const;

export const SEPARATOR_TEST_IDS = {
  SEPARATOR: 'separator',
} as const;

export const CATEGORY_CARD_TEST_IDS = {
  SKELETON: 'category-card_skeleton',
} as const;

export const Survey_CARD_TEST_IDS = {
  WRAPPER: 'survey-card_wrapper',
  SKELETON: 'survey-card_skeleton',
} as const;

export const QUESTION_HISTORY_ROW_TEST_IDS = {
  SKELETON: 'question-history-row_skeleton',
} as const;

export const PREVIOUS_RESPONSE_ROW_TEST_IDS = {
  SKELETON: 'previous-response-row_skeleton',
} as const;

export const LEADER_INSIGHT_ROW_TEST_IDS = {
  SKELETON: 'leader-insight-row_skeleton',
} as const;

export const QUESTION_SCHEDULE_ROW_TEST_IDS = {
  SKELETON: 'question-schedule-row_skeleton',
} as const;

export const SURVEY_OVERVIEW_ROW_TEST_IDS = {
  SKELETON: 'survey-overview-row_skeleton',
} as const;

export const PROFILE_REPORTS_ROW_TEST_IDS = {
  SKELETON: 'profile-reports-row_skeleton',
} as const;

export const USER_MANAGEMENT_ROW_TEST_IDS = {
  SKELETON: 'user-management-row_skeleton',
} as const;

export const USER_MANAGEMENT_ROLE_CELL_TEST_IDS = {
  TRIGGER: 'user-management-role-cell_trigger',
} as const;

export const REPORTS_OVEVIEW_ROW_TEST_IDS = {
  SKELETON: 'reports-overview-row_skeleton',
} as const;

export const TAG_TEST_IDS = {
  SPAN: 'tag_span',
  LABEL: 'tag_label',
} as const;

export const CATEGORY_POPUP_TEST_IDS = {
  STEP1: 'category-popup_step1',
  STEP1_ICON: 'category-popup_step1_icon',
  STEP2: 'category-popup_step2',
  STEP2_EDIT: 'category-popup_step2_edit',
} as const;

export const TRANSLATION_OVERVIEW_TEST_IDS = {
  EDIT_TRANSLATION_ICON: 'translation-oveview_edit_translation_icon',
} as const;

export const QUESTION_POPUP_TEST_IDS = {
  STEP1: 'question-popup_step1',
  STEP2: 'question-popup_step2',
  STEP2_EDIT: 'question-popup_step2_edit',
} as const;

export const CREATE_SURVEY_POPUP_TEST_IDS = {
  OPTION: 'create-survey-popup_option',
} as const;

export const EDIT_CELL_WRAPPER_TEST_IDS = {
  CHART: 'edit-cell_chart',
  SIDEBAR: 'edit-cell_sidebar',
  CLOSE_BUTTON: 'edit-cell_close_button',
} as const;

export const POPOVER_TEST_IDS = {
  CLOSE_BUTTON: 'popover_close_button',
} as const;

export const CHARTS_TEST_IDS = {
  TREND_LINE_CHART: 'charts_trend_line_chart',
  BAR_CHART: 'charts_bar_chart',
  PIE_CHART: 'charts_pie_chart',
  HEATMAP_CHART: 'charts_heatmap_chart',
  DISTRIBUTION_CHART: 'charts_distribution_chart',
  COMPARISON_CHART: 'charts_comparison_chart',
} as const;

export const EDIT_CELL_TEXT_TEST_IDS = {
  WRAPPER: 'edit-cell-text_wrapper',
} as const;

export const EDIT_CELL_METRICS_CARD_TEST_IDS = {
  WRAPPER: 'edit-cell-metrics-card_wrapper',
} as const;
